import { render, staticRenderFns } from "./LinkTextProperty.vue?vue&type=template&id=22735b37&scoped=true&"
import script from "./LinkTextProperty.vue?vue&type=script&lang=js&"
export * from "./LinkTextProperty.vue?vue&type=script&lang=js&"
import style0 from "./LinkTextProperty.vue?vue&type=style&index=0&id=22735b37&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.9.6_fb85a9817f99bdf862e5e3a442a1fb91/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22735b37",
  null
  
)

export default component.exports